
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/forge/cloudnative",
      function () {
        return require("private-next-pages/services/forge/cloudnative.tsx");
      }
    ]);
  